import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ShippingProfileEntity } from './types';

interface ShippingProfileState {
  profiles: ShippingProfileEntity[];
}

const initialState: ShippingProfileState = {
  profiles: [],
};

const shippingProfileSlice = createSlice({
  name: 'shippingProfiles',
  initialState,
  reducers: {
    setProfiles: (
      state,
      { payload }: PayloadAction<ShippingProfileEntity[]>
    ) => {
      state.profiles = payload;
    },
    updateProfile: (
      state,
      { payload }: PayloadAction<ShippingProfileEntity>
    ) => {
      const index = state.profiles.findIndex((p) => p._id === payload._id);
      if (index !== -1) {
        state.profiles[index] = payload;
      }
    },
  },
});

export const { setProfiles, updateProfile } = shippingProfileSlice.actions;

export default shippingProfileSlice.reducer;
